import { bonusesStatus } from "../../models/bonuses.model";
import types from "./types";

export function setBonusesStatus(data: bonusesStatus) {
    return {type: types.SET_STATUS, payload: data}
}
